import { useQuery, UseQueryResult } from 'react-query';
import { axiosInstance } from '../api/api';

export type Query = {
  sort?: string;
  size?: number;
  page?: number;
  search?: string;
  query?: string;
};

const staleTime = 1000 * 300; // 5 minutes

export interface Pageable<T> {
  content: T[];
  size: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  number: number;
  empty?: boolean;
  last?: boolean;
}

export function usePagination<Pageable>(path: string, query: Query, options?: Options): UseQueryResult<Pageable> {
  const mergedQuery = { size: query.size || 10, page: query.page || 0, sort: query.sort || '', query: query.query || '' };
  return useQuery<Pageable, Error>([path, `${mergedQuery.page}:${mergedQuery.size}:${mergedQuery.sort}:${mergedQuery.query}`], async (): Promise<Pageable> => {
    const result = await axiosInstance().get(path, { params: mergedQuery });
    return result.data as Pageable;
  }, { keepPreviousData: true, staleTime, enabled: options?.enabled ?? true });
}

export type GenericQuery = {
  [key: string]: string | number;
};

export type Options = {
  enabled: boolean;
};

export function useGenericPagination<Pageable>(path: string, query: GenericQuery, options?: Options): UseQueryResult<Pageable> {
  const mergedQuery = { size: query.size || 10, page: query.page || 0, sort: query.sort || '', ...query };
  return useQuery<Pageable, Error>([path, JSON.stringify(mergedQuery)], async (): Promise<Pageable> => {
    const result = await axiosInstance().get(path, { params: mergedQuery });
    return result.data as Pageable;
  }, { keepPreviousData: true, staleTime, enabled: options?.enabled ?? true, retry: 3 });
}
